import React from 'react';
import Landing from '../components/landing/Landing';

export default function HomePage() {
  return <Landing />;
}
